<template>
  <div class="boss-layout boss-layout-vertical boss-layout-fill">
    <div>
      <template v-if="displayKey === 'scouted'">
        <scout-members-scouted-filter
          ref="filter"
          :scouted-member-objects="memberObjects"
          @setMemberObjects="clearCheckedAndSetMemberObjects"
        />
      </template>
      <template v-else>
        <scout-members-filter
          ref="filter"
          :member-objects="memberObjects"
          :is-candidate="displayKey === 'candidate'"
          :is-liked="displayKey === 'liked'"
          :is-search="displayKey === 'search'"
          :is-recommended="displayKey === 'recommended'"
          :job-id="jobId"
          @setMemberObjects="clearCheckedAndSetMemberObjects"
        />
      </template>
    </div>
    <div class="pega-sticky">
      <div class="boss-batch-container clearfix padding-top-0">
        <scout-members-selector
          :display-count="displayCount"
          :count-from="countFrom"
          :count-to="countTo"
          :is-paging="count > countLimit"
          :show-selector="!isEmptyBulkRegister"
          @selectedMembers="selectedMembers"
        />
        <scout-members-bulk-register
          ref="scoutMembersBulkRegister"
          :job-id="jobId"
          :contract-id="contractId"
          :member-objects="checkedMemberObjects"
          :search-name="searchName"
          :search-condition-id="searchId"
          @fetch="$emit('fetch')"
          @clearCheckedMembers="clearCheckedMembers"
        />
      </div>
    </div>
    <div>
      <div class="boss-layout boss-layout-gap-between boss-layout-center">
        <div>
          <router-link
            v-if="displayKey !== 'scouted'"
            :to="{ name: 'settingMemberAttributes' }"
            class="boss-button boss-button-compact"
          >
            表示情報を編集
          </router-link>
        </div>
        <sort-pull-down
          :objects="renderingMemberObjects"
          :sort-item-map="sortItemMap"
          @setObjects="setMemberObjects"
        />
      </div>
    </div>
    <div>
      <template v-if="count > countLimit">
        <paginate
          v-model="currentPage"
          :page-count="pageCount"
          :page-range="2"
          :click-handler="fetchPages"
          :prev-text="'＜'"
          :next-text="'＞'"
          :active-class="'current'"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :disabled-class="'disabled'"
        />
      </template>
      <div
        class="boss-resumecard-list"
      >
        <template
          v-for="(memberObject, i) in infinityMemberObjects"
        >
          <scout-resume-card
            v-if="showResumeCard(memberObject.member.isScoutExcluded)"
            :key="i"
            :member-object="memberObject"
            :checked="checkedMemberIds"
            :is-publish-job="displayKey !== 'excluded' && isPublishJob"
            :contract-id="contractId"
            :is-scouted="displayKey === 'scouted'"
            :is-like="displayKey === 'liked'"
            :is-excluded="displayKey === 'excluded'"
            :is-candidate="displayKey === 'candidate'"
            :job-id="jobId"
            :searched-condition-name="searchName"
            :searched-condition-id="searchId"
            :shows-like-button="showsLikeButton"
            :shows-scout-button="showsScoutButton"
            :needs-check-control="needsCheckControl"
            :shows-check-control="!isEmptyBulkRegister"
            @checked="checked"
            @change="changed"
            @fetch="$emit('fetch')"
            @spliceCheckedMember="spliceCheckedMember"
            @updateLiked="updateLiked"
          />
        </template>
      </div>
    </div>
    <infinite-loading
      ref="infiniteLoading"
      @infinite="infiniteHandler"
    >
      <div
        slot="no-more"
        data-test="infinite-loading-no-more"
      >
        全{{ displayCount }}件
      </div>
      <div
        slot="no-results"
        data-test="no-results-label"
      >
        {{ noResultsLabel }}
      </div>
    </infinite-loading>
    <div
      v-if="showRecommendedLess"
      class="text-center"
      data-test="recommended-less"
    >
      <div>「本日のおすすめ」は、各求人のマッチング条件とtype会員の行動をもとにした、貴社へのスカウトおすすめ会員です。</div>
      <div>表示されない場合は、マッチング条件の変更などを制作担当者へご相談ください。</div>
    </div>
    <selected-counter
      :checked-count="checkedMemberIds.length"
    />
  </div>
</template>

<script>
import ScoutResumeCard from '@/components/organisms/ScoutResumeCard'
import ScoutMembersBulkRegister from '@/components/molecules/ScoutMembersBulkRegister'
import ScoutMembersSelector from '@/components/molecules/ScoutMembersSelector'
import SelectedCounter from '@/components/molecules/SelectedCounter'
import SortPullDown from '@/components/atoms/SortPullDown'
import ScoutMembersFilter from '@/components/molecules/ScoutMembersFilter'
import ScoutMembersScoutedFilter from '@/components/molecules/ScoutMembersScoutedFilter'
import InfiniteLoading from 'vue-infinite-loading'
import _ from 'lodash'
import { scoutResultSort, scoutResultSortScouted, scoutResultSortLiked, scoutRecommendedSort, scoutResultSortExcluded } from '@/lib/labelValueMappings'
import InfinityScrollIterator from '@/lib/infinityScrollIterator'
import { mapGetters } from 'vuex'
import Paginate from 'vuejs-paginate'
import Indicator from '@/lib/indicator'

export default {
  components: {
    ScoutResumeCard,
    ScoutMembersBulkRegister,
    ScoutMembersSelector,
    SelectedCounter,
    SortPullDown,
    ScoutMembersFilter,
    ScoutMembersScoutedFilter,
    InfiniteLoading,
    Paginate
  },
  props: {
    memberObjects: {
      type: Array,
      default: () => ([])
    },
    searchName: {
      type: String,
      default: ''
    },
    searchId: {
      type: Number,
      default: null
    },
    contractId: {
      type: Number,
      default: null
    },
    jobId: {
      type: Number,
      default: null
    },
    displayKey: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      default: 0
    },
    countLimit: {
      type: Number,
      default: 0
    },
    doSearch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checkedMemberIds: [],
      renderingMemberObjects: this.memberObjects,
      infinityMemberObjects: [],
      infinityScrollIterator: new InfinityScrollIterator(this.renderingMemberObjects),
      currentPage: 1,
      isEmptyBulkRegister: false
    }
  },
  computed: {
    checkedMemberObjects () {
      return this.checkedMemberIds.map(id => _(this.renderingMemberObjects).find({ id: id }))
    },
    sortItemMap () {
      if (this.displayKey === 'scouted') {
        return scoutResultSortScouted
      } else if (this.displayKey === 'liked') {
        return scoutResultSortLiked
      } else if (this.displayKey === 'recommended') {
        return scoutRecommendedSort
      } else if (this.displayKey === 'excluded') {
        return scoutResultSortExcluded
      } else {
        return scoutResultSort
      }
    },
    showsLikeButton () {
      if (!this.isSendScout) {
        return false
      }
      if (this.displayKey === 'liked') {
        return false
      } else if (this.displayKey === 'scouted') {
        return this.isPublishJob
      } else if (this.displayKey === 'excluded' || !this.isPublishJob) {
        return false
      }
      return true
    },
    showsScoutButton () {
      // スカウト送信権限なし
      if (!this.isSendScout) {
        return false
      } else if (this.displayKey === 'scouted') {
        // スカウト済み一覧なら表示
        return true
      }
      return this.displayKey !== 'excluded' && this.isPublishJob
    },
    noResultsLabel () {
      if (!Indicator.getLoadingStatus()) {
        if (this.displayKey === 'scouted') {
          return 'スカウト済み会員がいません。'
        }
        if (this.displayKey === 'liked') {
          return 'いいね済み会員がいません。'
        }
        if (this.displayKey === 'candidate') {
          return '送信候補がいません。'
        }
        if (this.displayKey === 'search') {
          return this.doSearch ? '検索結果がありません。' : '表示したい検索条件名を、選択してください'
        }
        if (this.displayKey === 'excluded') {
          return '除外者がいません。'
        }
        if (this.displayKey === 'recommended') {
          return 'おすすめ会員がいません。'
        }
      }
      return ''
    },
    ...mapGetters('contracts', [
      'isPublishedBy',
      'contracts'
    ]),
    ...mapGetters([
      'isSendScout'
    ]),
    showRecommendedLess () {
      return this.memberObjects.length <= 20 && this.displayKey === 'recommended' && !Indicator.getLoadingStatus()
    },
    pageCount () {
      return _.ceil(_.divide(this.count, this.countLimit))
    },
    countFrom () {
      return this.displayCount ? (this.currentPage - 1) * this.countLimit + 1 : 0
    },
    countTo () {
      return (this.currentPage - 1) * this.countLimit + this.displayCount
    },
    needsCheckControl () {
      return this.displayKey === 'scouted' || this.displayKey === 'liked' || this.displayKey === 'candidate' || this.displayKey === 'search' || this.displayKey === 'recommended'
    },
    isPublishJob () {
      return this.isPublishedBy(this.contractId, this.jobId)
    },
    shouldExcludedFilter () {
      return _.includes(['search', 'candidate', 'recommended'], this.displayKey)
    },
    displayCount () {
      return this.shouldExcludedFilter
        ? this.renderingMemberObjects.filter(memberObject => !memberObject.member.isScoutExcluded).length
        : this.renderingMemberObjects.length
    }
  },
  watch: {
    memberObjects (val) {
      this.$set(this, 'renderingMemberObjects', val)
    },
    renderingMemberObjects (val) {
      this.resetInfinityScroll(val)
    },
    jobId () {
      // 求人が変わった初期ページ
      this.$set(this, 'currentPage', 1)
      // 絞り込み初期化
      this.$refs.filter.clearFilterData()
    },
    count () {
      this.$set(this, 'currentPage', 1)
    }
  },
  mounted () {
    this.setIsEmptyBulkRegister()
  },
  methods: {
    checked (id) {
      if (!_.includes(this.checkedMemberIds, id)) {
        this.checkedMemberIds.push(id)
      }
    },
    changed (val) {
      if (_.includes(this.checkedMemberIds, val)) {
        this.checkedMemberIds.splice(this.checkedMemberIds.findIndex(n => n === val), 1)
      } else {
        this.checkedMemberIds.push(val)
      }
    },
    updateLiked (val) {
      _(this.memberObjects).filter(memberObject => memberObject.member.id === val.id)
        .forEach(memberObject => {
          _.set(memberObject, 'member.liked', val.liked)
        })
    },
    clearCheckedMembers () {
      this.$set(this, 'checkedMemberIds', [])
    },
    selectedMembers (selectLength, isChecked) {
      const memberObjects = this.needsCheckControl ? this.filterBulkChecked(this.renderingMemberObjects, isChecked) : this.renderingMemberObjects
      this.clearCheckedMembers()
      memberObjects.slice(0, selectLength).forEach((memberObject) => {
        if (isChecked && !_.includes(this.checkedMemberIds, memberObject.id)) {
          this.checkedMemberIds.push(memberObject.id)
        }
      })
    },
    setMemberObjects (memberObjects) {
      this.$set(this, 'renderingMemberObjects', memberObjects)
    },
    clearCheckedAndSetMemberObjects (memberObjects) {
      this.clearCheckedMembers()
      this.setMemberObjects(memberObjects)
    },
    fetchPages (pageNum) {
      this.$emit('fetch', pageNum)
    },
    infiniteHandler ($state) {
      const next = this.infinityScrollIterator.next()
      if (next.done) {
        $state.complete()
      } else {
        this.infinityMemberObjects.push(...next.value)
        $state.loaded()
      }
    },
    resetInfinityScroll (memberObjects) {
      if (this.$refs.infiniteLoading.stateChanger) {
        this.$refs.infiniteLoading.stateChanger.reset()
      }
      this.infinityMemberObjects = []
      this.infinityScrollIterator = new InfinityScrollIterator(memberObjects)
    },
    filterBulkChecked (memberObjects, isChecked) {
      const filterMemberObjects = memberObjects.filter(memberObject => {
        return (!_.get(memberObject, 'member.isScoutExcluded') &&
          !_.get(memberObject, 'member.isEntry') &&
          !_.get(memberObject, 'member.isCkUser') &&
          !_.get(memberObject, 'member.isScoutRejection') &&
          !_.get(memberObject, 'member.isWithdrawn') &&
          _.get(memberObject, 'member.subscriptions.scout') &&
          !_.get(memberObject, 'member.isScoutReserved'))
      })
      isChecked && this.$toasted.global.success({ message: 'スカウト送信可能な会員のみ選択しました。' })
      return this.displayKey === 'liked' ? filterMemberObjects.filter(memberObject => !_.get(memberObject, 'member.scouted')) : filterMemberObjects
    },
    spliceCheckedMember (memberObjectId) {
      this.checkedMemberIds.splice(this.checkedMemberIds.findIndex(id => id === memberObjectId), 1)
    },
    showResumeCard (isScoutExcluded) {
      return this.shouldExcludedFilter ? !isScoutExcluded : true
    },
    setIsEmptyBulkRegister () {
      this.$set(this, 'isEmptyBulkRegister', !this.getBulkRegisterOptionsCount())
    },
    getBulkRegisterOptionsCount () {
      return this.$refs.scoutMembersBulkRegister.bulkRegisterOptions.length
    }
  }
}
</script>
